module.exports = __webpack_public_path__ + "img/earnmoneybg.5ba58d98.png";